// One line on a held proposal: why it needs the athlete's OK (src/v2/held.js).
import React from 'react';
import { Hourglass } from 'lucide-react';
import { heldText } from '../../v2/held';

export default function HeldNote({ item }) {
  const text = heldText(item);
  if (!text) return null;
  return (
    <p className="m-0 flex items-start gap-1.5 type-caption text-text-secondary">
      <Hourglass size={12} className="mt-0.5 shrink-0" aria-hidden="true" /> {text}
    </p>
  );
}
